export const GOODS_ID_TYPE = {
  FREE: 0,
  FILE_PACKAGE: 2,
  MONTHLY_PRO: 1,
  ANNUAL_PRO: 3,
  PAGE_PACKAGE: 6,
  OCR_PAGE_PACKAGE: 15,
  GPT4_QUESTION_PACKAGE: 16,

  API_MONTHLY_BASIC: 4,
  API_ANNUAL_BASIC: 5,
  API_PAGE_PACKAGE: 8,
  API_QUESTION_PACKAGE: 9,
  API_PAGE_AND_QUESTION_PACKAGE: 10,
  API_LITE_PAGE_PACKAGE: 11,
  API_LITE_PAGE_AND_QUESTION_PACKAGE: 12,
  API_BASIC_PAGE_PACKAGE: 13,
  API_BASIC_PAGE_AND_QUESTION_PACKAGE: 14,
  API_OCR_PAGE_PACKAGE: 100, // todo OCR 页数包临时
  API_DOCUMENT_PACKAGE: 17,
};

export const PAY_METHOD = {
  CARD: 1,
  PAYPAL: 2,
  WECHAT: 3,
  ALIPAY: 4,
};

export const PAY_STATUS = {
  PAID: 'paid',
  APPROVED: 'approved',
  UNPAID: 'unpaid',
  REFUNDING: 'refunding',
  REFUNDED: 'refunded',
};

export const PRICING_TYPE_DATA = {
  FREE: 'Free',
  PRO: 'Pro',
  PRO_PLUS: 'Pro Plus',
};

export const PRICING_DESC_CONTENT = {
  PAGES_TEXT: 'pages',
  FILES_TEXT: 'files',
  TOKENS_TEXT: 'tokens',
  QUESTION_TEXT: 'questions',
};

export const PRICING_DESC_UNIT = {
  TOKENS_UNIT: '/doc,docx',
  SIZE_UNIT: '/file',
  FILES_UNIT: '/day',
  FILES_MON_UNIT: '/30 days',
  FILES_YEAR_UNIT: '/360 days',
  COLLECTION_UNIT: '/collection',
};

const FAQS_QUESTION1 = {
  question: 'Is ChatDOC free to use?',
  answer:
    'Yes, you can sign up for a free ChatDOC account. In the free plan, file size is now limited to 20 pages, and you can upload up to 2 docs. You can upgrade your plan to get more quota and pro features.',
  isDefaultShowAnswer: 'true',
};

const FAQS_QUESTION2 = {
  question: 'Where are my files stored?',
  answer:
    'We store your files in encrypted cloud storage to ensure their security. Our strict security protocols guarantee the utmost safety for your information and protect it from potential threats. You have full ownership and control of your data, and you can delete any files completely at any time.',
};

const FAQS_QUESTION3 = {
  question: 'Can I search across multiple documents?',
  answer:
    'Yes, of course! Upload a folder of files then chat with them at once. Get summarized answers from multiple files, and easily navigate through all files on the sidebar.',
};

const FAQS_QUESTION4 = {
  question: 'What new features are coming?',
  answer:
    'We are working on the following features, such as improved citations, more file types supported. Follow us on Twitter and stay up to date with our latest news!',
};

export const FAQS_DATA = [
  {
    position: 'left',
    faqsData: [FAQS_QUESTION1, FAQS_QUESTION3],
  },
  {
    position: 'right',
    faqsData: [FAQS_QUESTION2, FAQS_QUESTION4],
  },
];

export const FAQS_DATA_MOBILE = [
  FAQS_QUESTION1,
  FAQS_QUESTION2,
  FAQS_QUESTION3,
  FAQS_QUESTION4,
];

export const FAQS_WITHOUT_LOGIN_DATA = [
  'Is ChatDOC free to use?',
  'Where are my files stored?',
  'How to make query across multiple files?',
  'What can I benefit from Pro Plan?',
];

export const CHATDOC_ORDER_ID = 'chatdoc_order_id';

export const CHATDOC_BLOG_KEYWORDS = [
  'ChatDOC',
  'ChatPDF',
  'PDF reader',
  'GPT',
  'AI',
];
